var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"te-select-card",attrs:{"size":_vm.size,"theme":_vm.theme}},[_c('div',{staticClass:"te-select-card-icon tietoevry-icons-add"}),_c('div',{staticClass:"te-select-card-title"},[_vm._v(_vm._s(this.title))]),_c('div',{staticClass:"te-select-card-description"},[_vm._v(_vm._s(this.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }